<script>
	import { devices_settings } from 'src/stores';
	import {
		getBleTemperatureOffsetRange,
		isBleTemperatureOffsetFahrenheit,
	} from 'src/helpers/ble_settings_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	import OffsetThresholdWrapperGBLE from './OffsetThresholdWrapperGBLE.svelte';

	export let device;

	const useFahrenheit = isBleTemperatureOffsetFahrenheit(
		device,
		$devices_settings[real_id(device?.id)],
	);
	const { min, max } = getBleTemperatureOffsetRange(useFahrenheit);
</script>

<OffsetThresholdWrapperGBLE {device} setting="offset" type="temperature" {min} {max} />
